import Component from './Component';

export default class FooterLanguageLinks extends Component {
  load() {
    this.footerLanguageLinks();
    super.load();
  }

  footerLanguageLinks() {
    // redirect page on user interaction with language selector dropdown
    const langSelector = '.footer__lang-selector';
    $(langSelector).on('change', function () {
      let value = '';
      value = $(langSelector + ' option:selected').val() + '';

      // if value is "/" then no action is necessary.
      if (value.length > 1) {
        window.location.href = value; // redirect page to selected value
      }
    });

    // redirect page on user interaction with language selector dropdown
    const pageLangSelector = '.footer__pagelang-selector';
    $(pageLangSelector).on('change', function () {
      let value = $(pageLangSelector + ' option:selected').val() + '';

      // if value is "/" then no action is necessary.
      if (value.length > 1) {
        window.location.href = value; // redirect page to selected value
      }
    });
  }
}
